// Auto-generated from CSV files to avoid Create React App Webpack loader limitations for ?raw imports.

export const docClassCsv = `Classification type,Distribution protocol
Public,To anyone
Internal - may leave the organization,To Advisor and Company personnel
Internal - may not leave the organization,To Advisor and Company personnel
Confidential,To Company personnel
Confidential - Sensitive,To Authorized Company personnel`;

export const raciCsv = `Phase ID,Phase title,Task title,Responsible,Accountable,Consulted,Informed
1,Project onboarding,Create the project,,,,
1,Project onboarding,Create and communicate project plan,,,,
1,Project onboarding,Setup  base templates,,,,
2,Gap analysis,Trigger the gap analysis ,,,,
2,Gap analysis,Complete non technical assessment,,,,
2,Gap analysis,Complete technical assessment,,,,
2,Gap analysis,Consolidate the findings,,,,
2,Gap analysis,Create analysis report ,,,,
2,Gap analysis,Present and sign off analysis report,,,,
2,Gap analysis,Publish the baseline maturity map ,,,,
3,Organizational setup,Add users,,,,
3,Organizational setup,Set up collaboration channels,,,,
3,Organizational setup,Set up approval  mechanism,,,,
3,Organizational setup,Set up company theme on templates,,,,
3,Organizational setup,,,,,
4,Risk Assessment,Map internal context,,,,
4,Risk Assessment,Map external context,,,,
4,Risk Assessment,Create compliance register,,,,
4,Risk Assessment,Map threats and vulnerablities,,,,
4,Risk Assessment,Create risk register,,,,
4,Risk Assessment,Map the risk register to Annex A.,,,,
4,Risk Assessment,Publish the SOA,,,,
5,Control Implementation,Implement organizational controls,,,,
5,Control Implementation,Implement people controls,,,,
5,Control Implementation,Implement physical controls,,,,
5,Control Implementation,Implment technological controls,,,,
5,Control Implementation,Communicate implementation progress,,,,
5,Control Implementation,Conduct awareness and trainings,,,,
5,Control Implementation,Conduct user readiness assessments,,,,
6,Evidencing and monitoring,Collect evidences / coontrol,,,,
6,Evidencing and monitoring,Analyse evidences,,,,
6,Evidencing and monitoring,Take corrective action,,,,
6,Evidencing and monitoring,Recollect evidences,,,,
6,Evidencing and monitoring,Score evidences,,,,
6,Evidencing and monitoring,Submit and approve evidences,,,,
6,Evidencing and monitoring,Update standard IS questionnaire,,,,
6,Evidencing and monitoring,Create Company IS dashboard,,,,
7,Internal Audit,Create and communicate IA plan,,,,
7,Internal Audit,Conduct Documentation review,,,,
7,Internal Audit,Conduct Control implementation review,,,,
7,Internal Audit,Conduct VAPT,,,,
7,Internal Audit,Fill IA questionnaire ,,,,
7,Internal Audit,IA report submission,,,,
7,Internal Audit,Conduct Management review,,,,
8,Document Library,Add formal SOA,,,,
8,Document Library,Add Company IS public documents,,,,
8,Document Library,Add standard IS questionnaire,,,,`;

export const milestoneCsv = `WBS NUMBER,TASK TITLE,START DATE,DUE DATE,DURATION,,Dependencies,MONTH 1,,,,,,,,,,,,,,,MONTH 2,,,,,,,,,,,,,,,MONTH 3,,,,,,,,,,,,,,,MONTH 4,,,,,,,,,,,,,,
,,,,,,,WEEK 1,,,,,WEEK 2,,,,,WEEK 3,,,,,WEEK 4,,,,,WEEK 5,,,,,WEEK 6,,,,,WEEK 7,,,,,WEEK 8,,,,,WEEK 9,,,,,WEEK 10,,,,,WEEK 11,,,,,WEEK 12,,,,
,,,,,Key deliverable(s),,M,T,W,R,F,M,T,W,R,F,M,T,W,R,F,M,T,W,R,F,M,T,W,R,F,M,T,W,R,F,M,T,W,R,F,M,T,W,R,F,M,T,W,R,F,M,T,W,R,F,M,T,W,R,F,M,T,W,R,F
1,Project onboarding,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,
,,,,0,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,
,,,,0,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,
,,,,0,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,
,,,,0,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,
2,Gap analysis,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,
,,,,4,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,
,,,,3,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,
,,,,0,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,
,,,,0,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,
3,Organizational setup,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,
,,,,0,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,
,,,,0,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,
,,,,0,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,
,,,,0,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,
4,Risk Assesment,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,
,,,,0,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,
,,,,0,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,
,,,,0,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,
,,,,0,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,
5,Control Implementation,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,
,,,,0,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,
,,,,0,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,
,,,,0,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,
,,,,0,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,
6,Evidencing and monitoring,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,
,,,,0,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,
,,,,0,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,
,,,,0,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,
,,,,0,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,
7,Internal Audit,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,
,,,,0,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,
,,,,0,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,
,,,,0,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,
,,,,0,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,
8,Document Library,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,
,,,,0,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,
,,,,0,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,
,,,,0,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,
,,,,0,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,`;

export const resourceCsv = `,,,Est. Effort required (man days),,,
Phase ID,Phase title,Task title,Lead Advisor,Advisor,Associate Advisor,Technical Advisor
1,Project onboarding,Create the project,,,,
1,Project onboarding,Create and communicate project plan,,,,
1,Project onboarding,Setup  base templates,,,,
2,Gap analysis,Trigger the gap analysis ,,,,
2,Gap analysis,Complete non technical assessment,15,,,
2,Gap analysis,Complete technical assessment,,30,,
2,Gap analysis,Consolidate the findings,,,,
2,Gap analysis,Create analysis report ,,,,
2,Gap analysis,Present and sign off analysis report,,,,
2,Gap analysis,Publish the baseline maturity map ,,,,
3,Organizational setup,Add users,,,,
3,Organizational setup,Set up collaboration channels,,,,
3,Organizational setup,Set up approval  mechanism,,,,
3,Organizational setup,Set up company theme on templates,,,,
3,Organizational setup,,,,,
4,Risk Assessment,Map internal context,,,,
4,Risk Assessment,Map external context,,,,
4,Risk Assessment,Create compliance register,,,,
4,Risk Assessment,Map threats and vulnerablities,,,,
4,Risk Assessment,Create risk register,,,,
4,Risk Assessment,Map the risk register to Annex A.,,,,
4,Risk Assessment,Publish the SOA,,,,
5,Control Implementation,Implement organizational controls,,,,
5,Control Implementation,Implement people controls,,,,
5,Control Implementation,Implement physical controls,,,,
5,Control Implementation,Implment technological controls,,,,
5,Control Implementation,Communicate implementation progress,,,,
5,Control Implementation,Conduct awareness and trainings,,,,
5,Control Implementation,Conduct user readiness assessments,,,,
6,Evidencing and monitoring,Collect evidences / coontrol,,,,
6,Evidencing and monitoring,Analyse evidences,,,,
6,Evidencing and monitoring,Take corrective action,,,,
6,Evidencing and monitoring,Recollect evidences,,,,
6,Evidencing and monitoring,Score evidences,,,,
6,Evidencing and monitoring,Submit and approve evidences,,,,
6,Evidencing and monitoring,Update standard IS questionnaire,,,,
6,Evidencing and monitoring,Create Company IS dashboard,,,,
7,Internal Audit,Create and communicate IA plan,,,,
7,Internal Audit,Conduct Documentation review,,,,
7,Internal Audit,Conduct Control implementation review,,,,
7,Internal Audit,Conduct VAPT,,,,
7,Internal Audit,Fill IA questionnaire ,,,,
7,Internal Audit,IA report submission,,,,
7,Internal Audit,Conduct Management review,,,,
8,Document Library,Add formal SOA,,,,
8,Document Library,Add Company IS public documents,,,,
8,Document Library,Add standard IS questionnaire,,,,`;

